/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class NotificationsConstants {
}
NotificationsConstants.GLOBAL_KEY = 'window.sirius.shared.notifications';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90aWZpY2F0aW9ucy5jb25zdGFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL25vdGlmaWNhdGlvbnMvbm90aWZpY2F0aW9ucy5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sc0JBQXNCOztBQUNSLGlDQUFVLEdBQUcsb0NBQW9DLENBQUMifQ==